import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type SearchTableRowModalValuesParamsData = Parameters<
  typeof portalGatewayClient.table.searchTableRowModalValues
>[1]['data'];

type SearchTableRowModalValuesParamsContext = Parameters<
  typeof portalGatewayClient.table.searchTableRowModalValues
>[0];

export const searchTableRowModalValues = async (
  contentId: SearchTableRowModalValuesParamsContext,
  data: SearchTableRowModalValuesParamsData
) => {
  const response = await portalGatewayClient.table.searchTableRowModalValues(
    contentId,
    { data }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error searching modal values.'),
      response
    );
  }
  return response.data.data.modalValues;
};
